"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var ClickAwayListener = function ClickAwayListener(props) {
  var children = props.children,
    onClickAway = props.onClickAway,
    disabled = props.disabled;
  var rootRef = (0, _react.useRef)(null);
  var child = _react.Children.only(children);
  var handleRef = (0, _react.useCallback)(function (el) {
    rootRef.current = el;
    var originRef = child.props.ref;
    if (typeof originRef === 'function') {
      originRef(el);
      return;
    }
    if (_typeof(originRef) === 'object') {
      originRef.current = el;
    }
  }, [child]);
  (0, _react.useEffect)(function () {
    var element = rootRef.current;
    var listenClickAway = function listenClickAway(e) {
      var target = e.target;
      var badElements = !element || !(target instanceof HTMLElement);
      var badConditions = !onClickAway || disabled;
      if (badElements || badConditions) {
        return;
      }
      var isInside = element === target || element.contains(target);
      if (!isInside) {
        onClickAway(e);
      }
    };
    if (element || document.contains(element)) {
      window.addEventListener('mousedown', listenClickAway);
    }
    return function () {
      if (element) {
        window.removeEventListener('mousedown', listenClickAway);
      }
    };
  }, [onClickAway, disabled]);
  return /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
    ref: handleRef
  }));
};
var _default = ClickAwayListener;
exports["default"] = _default;